export const SET_ERROR = "SET_ERROR";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const VALID_TOKEN = "VALID_TOKEN";
export const INVALID_TOKEN = "INVALID_TOKEN";

export const TOGGLE_SIDEBAR_NAV = "TOGGLE_SIDEBAR_NAV";
export const CLOSE_SIDEBAR_NAV = "CLOSE_SIDEBAR_NAV";

export const GET_CLIENTS = "GET_CLIENTS";
export const LOADING_VIEW = "LOADING_VIEW";
export const FILTER_VIEW = "FILTER_VIEW";
export const CLEAR_FILTERS = "CLEAR_FILTERS";

export const GET_FIELD_COLLECTIONS = "GET_FIELD_COLLECTIONS";
export const GET_SINGLE_FIELD_COLLECTION = "GET_SINGLE_FIELD_COLLECTION";

export const SET_NOTIFICATION = "SET_NOTIFICATION";
export const CLEAR_NOTIFICATION = "CLEAR_NOTIFICATION";

export const GET_FORM = "GET_FORM";
export const GET_RECORD = "GET_RECORD";
export const GET_COMMENTS = "GET_COMMENTS";

export const ADD_SUBSCRIBER = "ADD_SUBSCRIBER";
export const REMOVE_SUBSCRIBER = "REMOVE_SUBSCRIBER";

export const SAVE_FIELD = "SAVE_FIELD";

export const SET_FORM_TEMPLATE = "SET_FORM_TEMPLATE";
export const CLEAR_FORM_TEMPLATE = "CLEAR_FORM_TEMPLATE";

export const CHANGE_INSTANCE = "CHANGE_INSTANCE";
export const CHANGE_VIEW_AS = "CHANGE_VIEW_AS";

export const BEGIN_REQUEST = "BEGIN_REQUEST";
export const END_REQUEST = "END_REQUEST";

export const RESIZE_WINDOW = "RESIZE_WINDOW";
export const VERSION_MISMATCH = "VERSION_MISMATCH";

export const GLOBAL_SEARCH = "GLOBAL_SEARCH";



// WEBPACK FOOTER //
// ./src/config/actionTypes.js